let morph = {
  init: function () {
    this.toggler();
    this.appHeight();
    // this.lenis();
    this.nav();
    this.marquee3k();
    this.slider();
    this.parallax();
    this.wowo();
    this.anchorLink();
    this.TweenMax();
    this.customScrollBar();
  },
  wowo: function () {
    let wTop = $(window).scrollTop(),
      wHeight = $(window).height(),
      wBottom = wTop + wHeight;
    $(".wowo:not(.animated)").each(function () {
      let me = $(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("wowo animated");
        }, 1500);
      }
    });
  },
  nav: function () {
    if (navigator.userAgent.match(/Trident\/7\./)) {
      document.body.addEventListener &&
        document.body.addEventListener("mousewheel", function () {
          event.preventDefault();
          let wd = event.wheelDelta;
          let csp = window.pageYOffset;
          window.scrollTo(0, csp - wd);
        });
    }
    let sh = $(window).scrollTop();

    if ($(window).width() < 991.8) {
      $("header").css("transform", "none");
      return;
    }

    const navTop = $("header.navbar").css("top").replace("px", "");
    const limitTop = navTop - 24;

    const top = $("header").css("top").replace("px", "") - 0;
    const headerHeight = $("header").outerHeight() + top;

    if (sh < limitTop) {
      $("header").css("transform", `translateY(-${sh}px)`);
      $("body").css({
        "--wishlist-tips-top": (headerHeight - sh) + "px",
      });
    } else if (sh >= limitTop) {
      $("header").css("transform", "translateY(-24px)");
      $("body").css({
        "--wishlist-tips-top": (headerHeight - 24) + "px",
      });
    }
  },
  toggler: function () {
    $(".hamburger").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!$(this).hasClass("open")) {
        $(this).addClass("open");
        $(".mobile-menu").addClass("show");
        $("html,body").addClass("overflow-hidden");
        $("html,body").attr("data-lenis-prevent", "true");
      } else {
        $(this).removeClass("open");
        $(".mobile-menu").removeClass("show");
        $("html,body").removeClass("overflow-hidden");
        $("html,body").removeAttr("data-lenis-prevent");
      }
    });

    // mobile menu
    if ($("header .mobile-menu").length > 0) {
      $("body").on("click", ".mobile-menu nav>ul>li.menu-item-has-children>a",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          const me = $(this);

          me.siblings(".sub-menu").addClass("show");
        }
      );

      $("body").on("click", ".mobile-menu .nav",
        function (e) {
          e.stopPropagation();
        }
      );


      $("body").on("click", ".mobile-menu .sub-menu .menu-content .btn-back button", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const me = $(this);
        me.parents(".sub-menu").removeClass("show");
      })


      $("body").on("click", ".mobile-menu .sub-menu .menu-content li a.li-head",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          const me = $(this);

          me.siblings(".li-body").addClass("show");
        }
      );

      $("body").on("click", ".mobile-menu .sub-menu .menu-content .li-body .btn-back-two button", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const me = $(this);
        me.parents(".li-body").removeClass("show");
      })




      $(document).on("click", function (e) {
        if (
          !$(e.target).closest(".mobile-menu .nav").length &&
          $(".mobile-menu").hasClass("show")
        ) {
          $(".hamburger").removeClass("open");
          $(".mobile-menu").removeClass("show");
          $("html,body").removeClass("overflow-hidden");
          $(".mobile-menu nav>ul>li.menu-item-has-children>a").siblings(".sub-menu").removeClass("show");
          $(".mobile-menu .sub-menu .menu-content li a.li-head").siblings(".li-body").removeClass("show");
        }
      });
    }





    // sub menu
    if ($("header .header-row").length > 0) {
      $("body").on("mouseenter click", ".header-row nav>ul>li", function (e) {
        e.stopPropagation();

        const me = $(this);
        me.parents(".nav").find("nav>ul>li").removeClass("active not-active");

        me.siblings("li").addClass("not-active");
        me.addClass("active");

        if (!me.hasClass("menu-item-has-children")) {
          $("header").removeClass("show-menu");
          return;
        }

        $("header").addClass("show-menu");
      });

      $("body").on("mouseleave", "header", function (e) {
        e.stopPropagation();

        const me = $(this);
        me.find(".header-row nav>ul>li").removeClass("not-active active");
        me.removeClass("show-menu");
      });

      $(document).on("click", function (e) {
        if (
          !$(e.target).closest("header").length &&
          $(".header-row nav>ul>li").hasClass("active")
        ) {
          $(".header-row nav>ul>li").removeClass("not-active active");
          $("header").removeClass("show-menu");
        }
      });

      // $("body").on("click", ".header-row nav>ul>li.menu-item-has-children .menu-link", function (e) {
      //   e.preventDefault();
      // });

      $("body").on(
        "wheel",
        ".header-row nav>ul>li.menu-item-has-children .sub-menu .card-box",
        function (e) {
          e.stopPropagation();
        }
      );
    }

    // switch product
    if ($(".collection-card-box").length > 0) {
      $("body").on(
        "click",
        ".collection-card-box .item .product-list .list .list-item",
        function (e) {
          e.stopPropagation();

          const me = $(this);
          const productWrapper = me
            .parents(".item")
            .find(".product-img-wrapper");
          me.siblings(".list-item").removeClass("active");
          me.addClass("active");

          const index = me.index();
          productWrapper.find(".product-img-item").removeClass("active");
          productWrapper.find(".product-img-item").eq(index).addClass("active");

          // data
          const dataName = me.attr("data-name");
          me.parents(".item")
            .find(".product-info")
            .find(".color")
            .text(dataName);
        }
      );
    }

    if ($(".block-filter-product-list").length > 0) {
      $("body").on(
        "click",
        ".block-filter-product-list .filter-wrapper .filter-row .btn button",
        function (e) {
          e.stopPropagation();

          const me = $(this).parents(".btn");
          const productList = me
            .parents(".filter-wrapper")
            .siblings(".product-list-box");

          me.toggleClass("show");

          productList.toggleClass("hide-filter");
        }
      );
    }

    // accordion
    if ($(".accordion-box").length > 0) {
      $(".accordion-box .accordion-head").click(function (e) {
        e.preventDefault();
        let me = $(this),
          parent = me.parents(".accordion-item");
        if (!parent.hasClass("active")) {
          me.siblings(".accordion-body").stop().slideDown(300);
          parent
            .addClass("active")
            .siblings("")
            .removeClass("active")
            .find(".accordion-body")
            .stop()
            .slideUp(300);
        } else {
          parent
            .removeClass("active")
            .find(".accordion-body")
            .stop()
            .slideUp(300);
        }
      });
    }

    $(document).on("click", (e) => {
      if (
        !$(e.target).closest(".accordion-box .accordion-item").length &&
        $(".accordion-box .accordion-item").hasClass("active")
      ) {
        $(".accordion-box .accordion-item")
          .removeClass("active")
          .find(".accordion-body")
          .stop()
          .slideUp(300);
      }
    });

    // size guide
    if ($(".popup-size-guide").length > 0) {
      $("body").on("click", ".btn-size-guide", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".popup-size-guide").addClass("open");
        $("html,body").addClass("overflow-hidden");
        $("html,body").attr("data-lenis-prevent", "true");
      });

      $("body").on("click", ".popup-size-guide .close", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".popup-size-guide").removeClass("open");
        $("html,body").removeClass("overflow-hidden");
        $("html,body").removeAttr("data-lenis-prevent");
      });

      $(document).on("click", (e) => {
        if (
          !$(e.target).closest(".popup-size-guide .size-guide-box").length &&
          $(".popup-size-guide").hasClass("open")
        ) {
          $(".popup-size-guide").removeClass("open");
          $("html,body").removeClass("overflow-hidden");
          $("html,body").removeAttr("data-lenis-prevent");
        }
      });
    }

    // block banner tab
    if ($(".block-banner-tab").length > 0) {
      function initTabs() {
        if ($(window).width() < 767.8) return;

        const item = $(".block-banner-tab .article-feature-card-box .item");

        item.on("mouseenter", function (e) {
          e.stopPropagation();

          const index = $(this).index();
          const parent = $(this).parents(".block-banner-tab");
          parent.find(".banner").slick("slickGoTo", index);
        });
      }

      initTabs();
    }

    // sort
    if ($(".sort-box").length > 0) {
      $("body").on("click", ".sort-box .sort-row .sort-desc", function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).parents(".drop-list").toggleClass("active");
        $(this).siblings(".list").stop().slideToggle(300);
      });

      $("body").on("click", ".sort-box .drop-list .list li", function (e) {
        e.stopPropagation();
        let me = $(this);
        me.parents(".drop-list")
          .removeClass("active")
          .find(".list")
          .stop()
          .slideUp(300);
        // me.siblings('li').removeClass('active');
        // me.addClass('active');

        const value = me.text().trim();
        me.parents(".drop-list").find(".sort-desc span").text(value);
      });

      function scrollToMatchingItem() {
        $(".sort-box").each(function () {
          const me = $(this);
          const value = me.find(".sort-desc span").text();
          if (value !== "") {
            me.find(".list li").each(function () {
              const listItemText = $(this).text().trim();
              if (listItemText === value) {
                $(this).addClass("active").siblings().removeClass("active");
              }
            });
          }
        });
      }
      scrollToMatchingItem();

      $(document).on("click", (e) => {
        if (
          !$(e.target).closest(".sort-box .drop-list").length &&
          $(".sort-box .drop-list").hasClass("active")
        ) {
          $(".sort-box .drop-list")
            .removeClass("active")
            .find(".list")
            .stop()
            .slideUp(300);
        }
      });
    }

    // video
    if ($(".block-banner-video").length > 0) {
      $(".block-banner-video .text .btn-control button").on(
        "click",
        function (e) {
          e.stopPropagation();

          const videoModal = $(this)
            .parents(".block-banner-video")
            .find(".popup-video");

          videoModal.addClass("open");
          $("html,body").addClass("overflow-hidden");
        }
      );

      $("body").on("click", ".popup-video", function (e) {
        e.stopPropagation();

        $(this).removeClass("open");
        $(this).find(".video-box video")[0].pause();
        $("html,body").removeClass("overflow-hidden");
      });

      $("body").on("click", ".popup-video .video-box", function (e) {
        e.stopPropagation();
      });
    }


    // 
    if ($(".collection-card-box").length > 0) {
      $("body").on("click", ".collection-card-box .item .quick-add-modal .mobile-add button", function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(".collection-card-box .quick-add-modal ul").hasClass("active")) {
          $(".collection-card-box .quick-add-modal ul").removeClass("active");
        }

        const me = $(this);
        me.parents(".quick-add-modal").find("ul").addClass("active");
      });

      $(document).on("click", (e) => {
        if (
          !$(e.target).closest(".collection-card-box .quick-add-modal ul").length &&
          $(".collection-card-box .quick-add-modal ul").hasClass("active")
        ) {
          $(".collection-card-box .quick-add-modal ul").removeClass("active");
        }
      })
    }


    // add to cart
    if ($(".mobile-add-cart-wrapper").length > 0) {


      function stickyBtn() {
        // const addBtn = $(".buy-buttons-block .add-to-cart-button");
        // const offsetTop = addBtn.offset().top;
        // const addBtnHeight = addBtn.outerHeight();

        const scrollTop = $(window).scrollTop();

        if ($("footer.footer").length > 0) {
          const footerOffsetTop = $("footer.footer").offset().top;
          const windowHeight = $(window).height();
          if (footerOffsetTop <= (scrollTop + windowHeight)) {
            $(".mobile-add-cart-wrapper").removeClass("is-show");
            return;
          }
        }

        $(".mobile-add-cart-wrapper").addClass("is-show");

        // if (scrollTop >= (offsetTop + addBtnHeight)) {
        //   ...
        // } else if (scrollTop < (offsetTop + addBtnHeight)) {
        //   $(".mobile-add-cart-wrapper").removeClass("is-show");
        // }
      }

      stickyBtn();

      $(window).on("scroll", function () {
        stickyBtn();
      });

      $("body").on("click", ".mobile-add-cart-wrapper .btn-box .add-to-cart button", function (e) {
        e.stopPropagation();

        const btn = $(".block-product-details .buy-buttons-block .add-to-cart-button");
        btn.trigger("click");
      });

      const checkedItem = $(".variant-picker__form .variant-option__button-label input[type=radio]:checked");
      const index = checkedItem.parents(".variant-picker__form .swiper-wrapper .variant-option__button-label").index();
      $(".mobile-add-cart-wrapper .product-container .product-item").removeClass("is-show").eq(index).addClass("is-show");



    }

    // gift
    if ($(".cart-drawer").length > 0) {
      $("body").on("click", ".cart-drawer .cart-gift .checkbox-btn", function (e) {
        e.stopPropagation();

        const me = $(this);

        if (!me.hasClass("checked")) {
          me.addClass("checked");
        } else {
          me.removeClass("checked");
        }

        let ids = [];
        const checkedInputs = $(".cart-drawer .cart-gift .checkbox-btn.checked input[type=checkbox]");
        if (checkedInputs.length > 0) {
          checkedInputs.each(function () {
            ids.push($(this).val());
          });
        }
        localStorage.setItem('giftIDs', JSON.stringify(ids));
        $("body").attr("data-ids", ids.join(","));
      })
    }
  },

  appHeight: function () {
    const doc = document.documentElement;
    let height = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    $("body").attr("style", "--height:" + height + "px");
    doc.style.setProperty("--vh", jQuery(window).innerHeight() * 0.01 + "px");

    if ($("header .header-row").length > 0) {
      const height = $("header .header-row .nav").outerHeight();
      $("header .header-row").css({
        "--nav-height": height + "px",
      });
    }

    if ($(".block-notification-bar").length > 0) {
      const height = $(".block-notification-bar").outerHeight();
      let top = $("header").css("top").replace("px", "") - 0;
      if ($(window).width() < 991.8) {
        top = height;
      }
      const headerHeight = $("header").outerHeight() + top;

      $("body").css({
        "--notification-height": height + "px",
        "--wishlist-tips-top": headerHeight + "px",
      });

      $("main.wrapper").css({
        "--header-height": headerHeight + "px",
      });

      $("header").css({
        "--header-height": headerHeight + "px",
      });
    }

    // quick add
    if ($(".product-card-box .add-wrapper .add").length > 0) {
      const el = $(".product-card-box .add-wrapper .add");
      el.each(function () {
        const width = el.outerWidth();
        $(this)
          .parents(".add-wrapper")
          .css({
            "--add-width": width + "px",
          });
      });
    }

    // list
    if ($(".block-filter-product-list").length > 0) {
      const list = $(
        ".block-filter-product-list .layout-bottom .product-list-box .filter-list"
      );
      const width = list.outerWidth();
      list.css({
        "--filter-list-width": width + "px",
      });
    }

    // toolbar
    if ($(".block-marquee").length > 0) {
      let height = $(".block-marquee").outerHeight();

      const remSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );

      const remValue = (32 / 16) * remSize;

      const adjustedHeight = height - remValue;

      $("main.wrapper").css({
        "--toolbar-height": adjustedHeight + "px",
      });
    }


    // 
    if ($("header").length > 0) {
      const stickyCartDom = $(".cart-drawer__content .cart-drawer__summary ");
      const height = stickyCartDom.outerHeight() || 0;

      $("body").css({
        "--sticky-cart-height": height + "px",
      })
    }
  },

  lenis: function () {
    const lenis = new Lenis({
      duration: 1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    if ($("textarea").length > 0) {
      $("textarea")
        .on("focus", function () {
          $(this).data("isScrolling", false);
        })
        .on("blur", function () {
          $(this).data("isScrolling", true);
        })
        .on("wheel", function (e) {
          if (!$(this).data("isScrolling")) {
            e.stopPropagation();
          }
        });
    }
  },

  marquee3k: function () {
    if ($(".marquee3k").length > 0) {
      Marquee3k.init();
    }
  },

  slider: function () {
    // 
    function prevUpdate(_this, _btn_prev, _btn_next) {
      const currentSlide = _this.slick('slickCurrentSlide');
      const maxSlide = Math.max(0, _this.slick('getSlick').slideCount - _this.slick('getSlick').options.slidesToShow);
      if (currentSlide === 0) {
        return;
      }

      if (currentSlide === 1) {
        _btn_prev.addClass('slick-disabled');
      }

      if (currentSlide === maxSlide) {
        _btn_next.removeClass('slick-disabled');
      }

      _this.slick('slickPrev');

    }

    // 
    function nextUpdate(_this, _btn_prev, _btn_next) {
      const currentSlide = _this.slick('slickCurrentSlide');
      const maxSlide = Math.max(0, _this.slick('getSlick').slideCount - _this.slick('getSlick').options.slidesToShow);
      if (currentSlide === maxSlide) {
        return;
      }

      if (currentSlide === (maxSlide - 1)) {
        _btn_next.addClass('slick-disabled');
      }

      if (currentSlide === 0) {
        _btn_prev.removeClass('slick-disabled');
      }

      _this.slick('slickNext');

    }


    if ($(".block-banner-tab").length > 0) {
      $(".block-banner-tab").each(function (index) {
        let $this = $(this);
        $this.addClass(`slider-${index}`);

        $this.find('.banner').slick({
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          infinite: false,
          focusOnSelect: true,
          arrows: false,
          fade: true,
          speed: 400,
          asNavFor: `.block-banner-tab.slider-${index} .article-feature-card-box`,
        });

        const length = $this.find('.article-feature-card-box .item').length
        $this.find('.article-feature-card-box').slick({
          dots: false,
          slidesToShow: length,
          slidesToScroll: 1,
          autoplay: false,
          infinite: false,
          focusOnSelect: true,
          arrows: false,
          fade: false,
          speed: 400,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                asNavFor: `.block-banner-tab.slider-${index} .banner`,
              }
            }
          ]
        });
      })

    }




    if ($(".block-banner").length > 0) {
      $(".block-banner .banner").each(function (index) {
        let $this = $(this);
        $this.addClass(`slider-${index}`);

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          arrows: false,
          dots: false,
          autoplay: true,
          draggable: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: true,
          focusOnSelect: true,
          speed: 400,
          autoplaySpeed: 5000,
        });
      });
    }

    if ($('.slider-card').length > 0) {
      $(".block-title-arrow-slider:not(.not-slider) .slider-card").each(function (index) {
        let $this = $(this);
        $this.addClass(`slider-${index}`);

        const btn_prev = $this.parents('.block-title-arrow-slider').find('.btn-box .btn-lt');
        const btn_next = $this.parents('.block-title-arrow-slider').find('.btn-box .btn-rt');

        $(window).on("resize", function () {
          if ($(window).width() < 575.8) {
            btn_prev.removeClass('slick-disabled');
            btn_next.removeClass('slick-disabled');
          }
        })

        function updateButtonState(slick) {
          if (slick.currentSlide === 0) {
            btn_prev.addClass('slick-disabled');
          } else {
            btn_prev.removeClass('slick-disabled');
          }

          const maxSlide = Math.max(0, slick.slideCount - slick.options.slidesToShow);
          if (slick.currentSlide >= maxSlide) {
            btn_next.addClass('slick-disabled');
          } else {
            btn_next.removeClass('slick-disabled');
          }
        }

        $this.on('init', function (e, slick) {
          updateButtonState(slick);
        });


        $this.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          fade: false,
          arrows: false,
          dots: false,
          autoplay: false,
          draggable: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: false,
          focusOnSelect: true,
          speed: 300,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                // infinite: true,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                // infinite: true,
              }
            },
          ]
        })

        let isClickable = true;

        btn_prev.on('click', function (e) {
          e.preventDefault();

          if (!isClickable) return;

          prevUpdate($this, btn_prev, btn_next);

          isClickable = false;
          setTimeout(() => {
            isClickable = true;
          }, 400);
        })

        btn_next.on('click', function (e) {
          e.preventDefault();

          if (!isClickable) return;

          nextUpdate($this, btn_prev, btn_next);

          isClickable = false;
          setTimeout(() => {
            isClickable = true;
          }, 400);
        })


        $this.on("swipe", function (e, slick) {
          updateButtonState(slick);
        });



        // Mouse wheel events
        const $carousel = $this;

        let isScrolling = false;
        const HORIZONTAL_THRESHOLD = 15;

        $carousel.on('wheel', function (e) {
          const deltaX = e.originalEvent.deltaX;

          if (Math.abs(deltaX) < HORIZONTAL_THRESHOLD) {
            return;
          }

          e.preventDefault();

          if (isScrolling) {
            return;
          }

          isScrolling = true;

          if (deltaX > 0) {
            nextUpdate($this, btn_prev, btn_next);
          } else {
            prevUpdate($this, btn_prev, btn_next);
          }

          setTimeout(() => {
            isScrolling = false;
          }, 300);
        });


        // 
        const parent = $this.parents('.block-title-arrow-slider');
        if (parent.hasClass('type-2') && parent.find('.slider-card .item video').length > 0) {
          const videos = document.querySelectorAll('.slider-card .item video');

          videos.forEach(video => {

            video.load();

            video.addEventListener('loadedmetadata', () => {
              if (video.paused) {
                setTimeout(() => {
                  video.play()
                    .then(() => {
                      setTimeout(() => {
                        video.pause();
                        video.currentTime = 0;
                      }, 50);
                    })
                    .catch(err => {
                      if (err.name === 'AbortError') {
                        console.log('Video playback was interrupted by the system. Try to set the current time directly:', err);
                        video.currentTime = 0;
                      } else {
                        console.log('Autoplay blocked by browser:', err);
                      }
                    });
                }, 100);
              }
            });

            video.addEventListener('error', (err) => {
              console.log('Video loading error:', err);
            });
          });



          function initVideoInteraction() {
            const item = parent.find('.slider-card .item');
            item.off('mouseenter mouseleave click');

            const isTouchDevice = () => {
              const hasTouch = !!('ontouchstart' in window ||
                (window.DocumentTouch && document instanceof DocumentTouch) ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0);
              if (!hasTouch) return false;

              const ua = navigator.userAgent.toLowerCase();
              const isDesktop = ua.includes('windows') || ua.includes('macintosh');
              return !isDesktop;
            };

            if (isTouchDevice()) {
              item.on('click', function (e) {
                e.stopPropagation();
                const video = $(this).find('video')[0];
                const brothers = $(this).siblings('.item').find('video');

                if (video.paused) {
                  brothers.each(function () {
                    $(this)[0].pause();
                  });
                  video.play();
                } else {
                  video.pause();
                }
              });
            } else {
              item.on('mouseenter', function (e) {
                e.stopPropagation();
                $(this).find('video')[0].play();
              }).on('mouseleave', function (e) {
                e.stopPropagation();
                $(this).find('video')[0].pause();
              });
            }
          }

          initVideoInteraction();

          let resizeTimer;
          $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(initVideoInteraction, 200);
          });
        }
      })
    }


    if ($(".block-new-arrivals-showcase").length > 0) {
      function slideInit() {
        if ($(window).width() < 767.8) {
          $(".block-new-arrivals-showcase .row .product-card-box:not(.slick-initialized)").each(function (index) {
            let $this = $(this);
            // $this.addClass(`slider-article-${index}`);
            $this.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: false,
              arrows: false,
              dots: true,
              autoplay: false,
              draggable: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              infinite: false,
              focusOnSelect: true,
              speed: 400,
              autoplaySpeed: 5000,
              centerMode: true,
              variableWidth: true,
            });
          });
        } else if ($(window).width() > 767.8) {
          $(".block-new-arrivals-showcase .row .product-card-box.slick-initialized").each(function (index) {
            let $this = $(this);
            $this.slick("unslick");
          });
        }
      }

      slideInit();
      $(window).on("resize", function () {
        slideInit();
      });
    }

    if ($(".block-featured-articles").length > 0) {
      function slideInit() {
        if ($(window).width() < 767.8) {
          $(".block-featured-articles .text .product-card-box:not(.slick-initialized)").each(function (index) {
            let $this = $(this);
            // $this.addClass(`slider-article-${index}`);
            $this.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: true,
              arrows: false,
              dots: true,
              autoplay: false,
              draggable: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              infinite: true,
              focusOnSelect: true,
              speed: 400,
              autoplaySpeed: 5000,
            });
          });
        } else if ($(window).width() > 767.8) {
          $(".block-featured-articles .text .product-card-box.slick-initialized").each(function (index) {
            let $this = $(this);
            $this.slick("unslick");
          });
        }
      }

      slideInit();
      $(window).on("resize", function () {
        slideInit();
      });
    }



    // block-redeem-points
    if ($(".block-redeem-points").length > 0) {
      function slideInit() {
        if ($(window).width() < 767.8) {
          $(".block-redeem-points .text .points-box:not(.slick-initialized)").each(function (index) {
            let $this = $(this);
            // $this.addClass(`slider-article-${index}`);
            $this.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: false,
              arrows: false,
              dots: true,
              autoplay: false,
              draggable: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              infinite: false,
              focusOnSelect: true,
              speed: 400,
              autoplaySpeed: 5000,
              centerMode: true,
              variableWidth: true,
            });
          });
        } else if ($(window).width() > 767.8) {
          $(".block-redeem-points .text .points-box.slick-initialized").each(function (index) {
            let $this = $(this);
            $this.slick("unslick");
          });
        }
      }

      slideInit();
      $(window).on("resize", function () {
        slideInit();
      });
    }



    if ($(".collection-card-box .item .product-list").length > 0) {
      $(".collection-card-box .item .product-list.swiper").each(function (index) {
        const swiperContainer = $(this);
        const list = swiperContainer.find(".list");

        if (!swiperContainer.data('swiperInstance')) {
          swiperContainer.data('swiperInstance', null);
        }

        function initSwiperIfNeeded() {
          const domsCount = list.find(".list-item").length;
          const currentInstance = swiperContainer.data('swiperInstance');

          if (currentInstance && domsCount <= 6) {
            currentInstance.destroy();
            swiperContainer.data('swiperInstance', null);
            swiperContainer.find('.swiper-button-next, .swiper-button-prev').remove();
            swiperContainer.removeClass("is-slick");
          } else if (!currentInstance && domsCount > 6) {
            swiperContainer.addClass("is-slick");
            if (swiperContainer.find('.swiper-button-next').length === 0) {
              swiperContainer.append(`
          <button class="swiper-button-prev" aria-label="Previous"></button>
          <button class="swiper-button-next" aria-label="Next"></button>
        `);
            }

            const newInstance = new Swiper(swiperContainer[0], {
              slidesPerView: "auto",
              slidesPerGroup: 5,
              resistance: true,
              resistanceRatio: 0,
              nested: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
            swiperContainer.data('swiperInstance', newInstance);
          }
        }

        initSwiperIfNeeded();

        let resizeTimer;
        $(window).on('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            // swiperContainer[0].offsetWidth;
            initSwiperIfNeeded();
          }, 100);
        });
      });



    }


    // let swiperInstances = [];

    // function initOrDestroySwipers() {
    //   const $swiperContainers = $(".block-product-details .layout-right .variant-picker .variant-option .swiper");
    //   const isDesktop = window.innerWidth > 767.8;

    //   swiperInstances.forEach(instance => {
    //     if (instance && instance.destroy) {
    //       instance.destroy(true, true);
    //     }
    //   });
    //   swiperInstances = [];

    //   if (isDesktop && $swiperContainers.length > 0) {
    //     $swiperContainers.each(function (index) {
    //       const swiperContainer = $(this)[0];
    //       const instance = new Swiper(swiperContainer, {
    //         slidesPerView: "auto",
    //         resistance: true,
    //         freeMode: true,
    //         preventClicks: false,
    //         preventClicksPropagation: false
    //       });
    //       swiperInstances.push(instance);
    //     });
    //   }
    // }

    // initOrDestroySwipers();

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initOrDestroySwipers, 100);
    });




    if ($(".block-title-link-card.has-slider").length > 0) {
      $(".block-title-link-card.has-slider").each(function (index, element) {
        let swiperContainer = $(element).find(".swiper.collection-card-box");

        let swiperPrevBtn = $(element).find(".btn-box .btn-lt");
        let swiperNextBtn = $(element).find(".btn-box .btn-rt");

        function updateButtonState(swiper) {
          if (swiper.isBeginning) {
            swiperPrevBtn.addClass("slick-disabled");
          } else {
            swiperPrevBtn.removeClass("slick-disabled");
          }

          if (swiper.isEnd) {
            swiperNextBtn.addClass("slick-disabled");
          } else {
            swiperNextBtn.removeClass("slick-disabled");
          }
        }

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: 2,
            resistance: true,
            spaceBetween: 8,
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            mousewheel: {
              forceToAxis: true,
            },
            breakpoints: {
              768: {
                slidesPerView: "auto",
                resistance: true,
                // freeMode: true,
                spaceBetween: 0,
              },
            },
            on: {
              init: function (swiper) {
                updateButtonState(swiper);
              },
              progress: function (swiper) {
                updateButtonState(swiper);
              },
            },
          });

          swiperPrevBtn.on("click", function () {
            swiperInstance.slidePrev();
          });
          swiperNextBtn.on("click", function () {
            swiperInstance.slideNext();
          });
        }
      });
    }

    if ($(".cart-slider").length > 0) {
      $(".cart-slider").each(function (index, element) {
        const $element = $(element);
        let swiperContainer = $element.find(".swiper");

        let swiperPrevBtn = $element.find(".arrow-box .arrow-lt");
        let swiperNextBtn = $element.find(".arrow-box .arrow-rt");

        function updateButtonState(swiper) {
          if (swiper.isBeginning) {
            swiperPrevBtn.addClass("slick-disabled");
          } else {
            swiperPrevBtn.removeClass("slick-disabled");
          }

          if (swiper.isEnd) {
            swiperNextBtn.addClass("slick-disabled");
          } else {
            swiperNextBtn.removeClass("slick-disabled");
          }
        }

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            on: {
              init: function (swiper) {
                updateButtonState(swiper);
              },
              progress: function (swiper) {
                updateButtonState(swiper);
              }
            }
          });

          swiperContainer.data('swiperInstance', swiperInstance);

          swiperPrevBtn.on("click", function () {
            swiperInstance.slidePrev();
          });
          swiperNextBtn.on("click", function () {
            swiperInstance.slideNext();
          });
        }
      });
    }


    if ($(".product-card-box").length > 0) {
      function slideInit() {
        if ($(window).width() > 767.8) {
          $(".product-card-box .item .add-wrapper .size-list:not(.slick-initialized)").each(function (index) {
            let $this = $(this);
            $this.addClass(`product-card-box-${index}`);
            $this.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              fade: false,
              arrows: true,
              dots: false,
              autoplay: false,
              draggable: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              infinite: true,
              focusOnSelect: true,
              speed: 400,
              autoplaySpeed: 5000,
              prevArrow: '<button class="btn-prev"></button>',
              nextArrow: '<button class="btn-next"></button>',
            });

            const slideCount = $this.slick("getSlick").slideCount;
            if (slideCount <= 5) {
              $this.find(".btn-next").hide();
            }
          });
        } else if ($(window).width() < 767.8) {
          $(".product-card-box .item .add-wrapper .size-list.slick-initialized").each(function (index) {
            let $this = $(this);
            $this.slick("unslick");
          });
        }
      }

      slideInit();
      $(window).on("resize", function () {
        slideInit();
      });

      document
        .querySelectorAll(".product-card-box .item .add-wrapper .add button")
        .forEach((button) => {
          button.addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.closest(".add-wrapper").classList.add("active");
          });
        });

      document
        .querySelectorAll(".product-card-box .item .add-wrapper .size-list .btn-next")
        .forEach((button) => {
          button.addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
          });
        });

      $(".product-card-box .item").on("dragstart", function (e) {
        e.preventDefault();
      });


      $("body").on(
        "mouseleave",
        ".product-card-box .item .add-wrapper",
        function (e) {
          e.stopPropagation();

          let me = $(this);
          me.removeClass("active");
        }
      );

      $(document).on("click", (e) => {
        if (
          !$(e.target).closest(".product-card-box .item .add-wrapper.active")
            .length &&
          $(".product-card-box .item .add-wrapper").hasClass("active")
        ) {
          $(".product-card-box .item .add-wrapper").removeClass("active");
        }
      });
    }

    if ($(".slider-article").length > 0) {
      $(".slider-article").each(function (index) {
        let $this = $(this);
        $this.addClass(`slider-article-${index}`);
        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: false,
          arrows: true,
          dots: true,
          autoplay: false,
          draggable: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: false,
          focusOnSelect: true,
          speed: 400,
          autoplaySpeed: 5000,
          prevArrow: '<div class="btn-lt"><button><span></span></button></div>',
          nextArrow: '<div class="btn-rt"><button><span></span></button></div>',
          asNavFor: ".img-and-slider .slider-bg-img-" + index,
        });
      });

      $(".slider-article")
        .parents(".img-and-slider")
        .find(".slider-bg-img")
        .each(function (index) {
          let $this = $(this);
          $this.addClass(`slider-bg-img-${index}`);
          $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            dots: false,
            autoplay: false,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: false,
            focusOnSelect: true,
            speed: 400,
            autoplaySpeed: 5000,
            asNavFor: ".img-and-slider .slider-article-" + index,
          });
        });
    }

    if ($(".popup-image-zoom .slider-img-zoom").length > 0) {

      // panzoom
      const ZOOM_LEVELS = [1, 2, 3];
      let currentZoomIndex = 0;
      let panzoomContainer = [];

      $(".popup-image-zoom .slider-box .zoom-area-wrapper").each(function (index) {
        const image = $(this)[0];

        const panzoom = Panzoom(image, {
          maxZoom: 3,
          minZoom: 1,
          zoomSpeed: 0.1,
          disablePan: false,
          contain: "outside",
          smoothScroll: true,
        });

        panzoomContainer.push(panzoom);


        const wrapper = $(this), imageBox = wrapper.parents(".image-zoom-box");

        imageBox.find(".controls .zoom-in").on("click", function (e) {
          const me = $(this);

          if (
            !imageBox.find(".slider-img-zoom").hasClass("item-overflow")
          ) {
            imageBox.find(".slider-img-zoom").addClass("item-overflow");
          }
          const zoomOut = me.siblings(".zoom-out");
          if (zoomOut.hasClass("disabled")) {
            zoomOut.removeClass("disabled");
          }

          if (currentZoomIndex >= ZOOM_LEVELS.length - 1) {
            return;
          }

          currentZoomIndex++;
          const targetScale = ZOOM_LEVELS[currentZoomIndex];
          panzoom.zoom(targetScale, { animate: true });
          if (targetScale === ZOOM_LEVELS.length) {
            me.addClass("disabled");
          }
        })


        imageBox.find(".controls .zoom-out").on("click", function (e) {
          const me = $(this);

          const zoomIn = me.siblings(".zoom-in");
          if (zoomIn.hasClass("disabled")) {
            zoomIn.removeClass("disabled");
          }

          if (currentZoomIndex <= 0) {
            return;
          }

          currentZoomIndex--;
          const targetScale = ZOOM_LEVELS[currentZoomIndex];
          panzoom.zoom(targetScale, { animate: true });
          if (targetScale === 1) {
            me.addClass("disabled");
            me.parents(".image-zoom-box").find(".slider-img-zoom").removeClass("item-overflow");
          }
        });

      });




      function panzoomReset() {
        currentZoomIndex = 0;
        panzoomContainer?.forEach((panzoom) => {
          panzoom.zoom(1, { animate: true });
        })
        $(".popup-image-zoom .controls .zoom-out").addClass("disabled");
        $(".popup-image-zoom .controls .zoom-in").removeClass("disabled");
        $(".popup-image-zoom .slider-img-zoom").removeClass("item-overflow");
      }

      $(".popup-image-zoom .controls .zoom-out").addClass("disabled");



      // slider
      $(".popup-image-zoom .slider-img-zoom").each(function (index) {
        let $this = $(this);
        $this.addClass(`slider-img-zoom-${index}`);

        const btn_prev = $this.parents(".image-zoom-box").find(".btn-lt");
        const btn_next = $this.parents(".image-zoom-box").find(".btn-rt");

        function updateButtonState(slick) {
          if (slick.currentSlide === 0) {
            btn_prev.addClass("slick-disabled");
          } else {
            btn_prev.removeClass("slick-disabled");
          }

          const maxSlide = Math.max(
            0,
            slick.slideCount - slick.options.slidesToShow
          );
          if (slick.currentSlide >= maxSlide) {
            btn_next.addClass("slick-disabled");
          } else {
            btn_next.removeClass("slick-disabled");
          }
        }

        $this.on("init", function (e, slick) {
          updateButtonState(slick);
        });

        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: false,
          arrows: false,
          dots: false,
          autoplay: false,
          draggable: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          infinite: false,
          focusOnSelect: false,
          speed: 400,
          autoplaySpeed: 5000,
          swipe: false,
        });

        let isClickable = true;

        btn_prev.on('click', function (e) {
          e.preventDefault();

          if (!isClickable) return;

          prevUpdate($this, btn_prev, btn_next);
          panzoomReset();

          isClickable = false;
          setTimeout(() => {
            isClickable = true;
          }, 400);
        })

        btn_next.on('click', function (e) {
          e.preventDefault();

          if (!isClickable) return;

          nextUpdate($this, btn_prev, btn_next);
          panzoomReset();

          isClickable = false;
          setTimeout(() => {
            isClickable = true;
          }, 400);
        })

        $this.on("afterChange", function (e, slick) {
          updateButtonState(slick);
        });


        const zoomBox = $this.parents(".image-zoom-box");
        zoomBox.addClass("is-hide");
      });





      // popup
      $("body").on(
        "click",
        ".block-product-details .layout-left .swiper .swiper-wrapper .swiper-slide",
        function (e) {
          e.stopPropagation();

          const index = $(this).index();
          const swiperBox = $(this).parents(".swiper-box"),
            swiperBoxIndex = swiperBox.index();
          const mySlick = $(".popup-image-zoom .image-zoom-box").eq(swiperBoxIndex).find(".slider-img-zoom");

          $(".popup-image-zoom .image-zoom-box").eq(swiperBoxIndex).removeClass("is-hide");
          $(".popup-image-zoom").addClass("open");
          $("html,body").addClass("overflow-hidden");
          $("html,body").attr("data-lenis-prevent", "true");
          mySlick.slick("slickGoTo", index, true);
        }
      );

      $("body").on("click", ".popup-image-zoom .close", function (e) {
        e.stopPropagation();

        $(".popup-image-zoom").removeClass("open");
        $("html,body").removeClass("overflow-hidden");
        $("html,body").removeAttr("data-lenis-prevent");
        setTimeout(function () {
          panzoomReset();
          $(".popup-image-zoom .image-zoom-box").addClass("is-hide");
        }, 300);
      });


    }






    if ($(".slider-post-wrapper").length > 0) {
      $(".slider-post-wrapper").each(function (index, element) {
        let swiperContainer = $(element).find(".swiper");

        let swiperPrevBtn = $(element).find(".btn-box .btn-lt");
        let swiperNextBtn = $(element).find(".btn-box .btn-rt");

        function updateButtonState(swiper) {
          if (swiper.isBeginning) {
            swiperPrevBtn.addClass("slick-disabled");
          } else {
            swiperPrevBtn.removeClass("slick-disabled");
          }

          if (swiper.isEnd) {
            swiperNextBtn.addClass("slick-disabled");
          } else {
            swiperNextBtn.removeClass("slick-disabled");
          }
        }

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            // freeMode: true,
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            on: {
              init: function (swiper) {
                updateButtonState(swiper);
              },
              progress: function (swiper) {
                updateButtonState(swiper);
              },
            },
          });

          swiperPrevBtn.on("click", function () {
            swiperInstance.slidePrev();
          });
          swiperNextBtn.on("click", function () {
            swiperInstance.slideNext();
          });
        }
      });
    }



    if ($(".block-product-details .swiper-box").length > 0) {
      $(".block-product-details .swiper-box").each(function (index, element) {
        let swiperContainer = $(element).find(".swiper");

        if (swiperContainer.length > 0) {
          let swiperInstance;
          function initSwiper() {
            swiperInstance = new Swiper(swiperContainer[0], {
              slidesPerView: "auto",
              resistance: true,
              // freeMode: true,
              scrollbar: {
                el: ".swiper-scrollbar",
              },
              breakpoints: {
                768: {
                  scrollbar: {
                    el: null,
                  },
                },
              },
            });
          }

          function reInitSwiper() {
            if ($(window).width() > 767.8 && swiperInstance !== null) {
              swiperInstance.destroy();
              swiperInstance = null;
            } else if ($(window).width() < 767.8 && swiperInstance === null) {
              initSwiper();
            }
          }

          initSwiper();
          reInitSwiper();

          $(window).on("resize", function () {
            reInitSwiper();
          });
        }
      });
    }



    if ($(".block-title-link-card:not(.has-slider)").length > 0) {
      $(".block-title-link-card:not(.has-slider)").each(function (index, element) {
        let swiperContainer = $(element).find(".swiper");

        if (swiperContainer.length > 0) {
          let swiperInstance;
          function initSwiper() {
            swiperInstance = new Swiper(swiperContainer[0], {
              slidesPerView: 2,
              resistance: true,
              spaceBetween: 8,
              scrollbar: {
                el: ".swiper-scrollbar",
              },
              breakpoints: {
                768: {
                  scrollbar: {
                    el: null,
                  },
                },
              },
            });
          }

          function reInitSwiper() {
            if ($(window).width() > 767.8 && swiperInstance !== null) {
              swiperInstance.destroy();
              swiperInstance = null;
            } else if ($(window).width() < 767.8 && swiperInstance === null) {
              initSwiper();
            }
          }

          initSwiper();
          reInitSwiper();

          $(window).on("resize", function () {
            reInitSwiper();
          });
        }
      });
    }
  },

  parallax: function () {
    if ($(".parallax-img-wrapper").length > 0) {
      const parallaxWrapper = $(".parallax-img-wrapper .parallax-content");
      const doms = parallaxWrapper.find(".parallax-item");
      const domsClone = doms.clone();

      function updateLayout() {
        const width = $(window).width();
        let groupSize = 0;

        if (width > 991.8) {
          groupSize = 2;
        } else if (width > 767.8) {
          groupSize = 3;
        } else {
          groupSize = 4;
        }

        parallaxWrapper.empty();

        domsClone.each(function (index) {
          if (index % groupSize === 0) {
            const column = $('<div class="parallax-column"></div>');
            column.appendTo(parallaxWrapper);
          }

          $(this).appendTo(parallaxWrapper.find(".parallax-column").last());
        });
      }

      const rellax = function () {
        const parallaxSection = parallaxWrapper.parents(".block-testimonial-tile");
        if (parallaxSection.hasClass("type-2")) {
          return;
        }

        parallaxWrapper.find(".parallax-column").each(function (index) {
          const $this = $(this);
          const windowScrollTop = $(window).scrollTop();
          const windowHeight = $(window).height();
          const windowMiddle = windowScrollTop + windowHeight / 2;

          const $content = $this.parents(".parallax-content");
          const elementTop = $content.offset().top;
          const elementHeight = $content.outerHeight();
          const elIndex = index + 1;

          const distanceFromMiddle = elementTop - windowMiddle;

          if (
            distanceFromMiddle <= 0 &&
            distanceFromMiddle > -elementHeight
          ) {
            const progress =
              1 -
              (distanceFromMiddle + elementHeight) / (elementHeight);

            let transformValue =
              elIndex % 2 === 0 ? progress * 25 * -1 : progress * 25;

            $this.css("transform", `translateY(${transformValue}px)`);
          } else if (distanceFromMiddle <= -elementHeight) {
            let lastValue = elIndex % 2 === 0 ? -25 : 25;
            $this.css("transform", `translateY(${lastValue}px)`);
          } else {
            $this.css("transform", "none");
          }
        });
      };

      updateLayout();

      $(window).on("resize", function () {
        updateLayout();
      });


      rellax();
      $(window).on("scroll", function () {
        rellax();
      });
    }
  },

  pageScroll: (position, diff = 0, duration = 600) => {
    document.documentElement.style.scrollBehavior = 'auto';
    jQuery("html,body").animate({ scrollTop: position - diff }, duration, () => {
      document.documentElement.style.scrollBehavior = '';
    });
  },
  anchorLink: function () {
    let _this = this;

    jQuery("body").on("click", ".explore-btn", (e) => {
      e.preventDefault();
      let anchorPosition = jQuery(e.target)
        .parents("section")
        .next()
        .offset().top,
        // headerHeight = jQuery('header').outerHeight() - 1 || 0;
        top = $("header").css("top").replace("px", "") - 0;
      let headerHeight = $("header").outerHeight() + top - 1 || 0;
      _this.pageScroll(anchorPosition, headerHeight);
    });

    jQuery("body").on("click", "a", (e) => {
      if (jQuery(e.target.hash).length) {
        e.preventDefault();

        let anchorPosition = jQuery(e.target.hash).offset().top,
          // headerHeight = (jQuery('header').outerHeight() - 1) || 0;
          top = $("header").css("top").replace("px", "") - 0;
        let headerHeight = $("header").outerHeight() + top - 1 || 0;

        _this.pageScroll(anchorPosition, headerHeight);
      }
    });

    const hash = window.location.hash;

    if (hash) {
      let anchorPosition = jQuery(hash).offset().top,
        // headerHeight = (jQuery('header').outerHeight() - 1) || 0;
        top = $("header").css("top").replace("px", "") - 0;
      let headerHeight = $("header").outerHeight() + top - 1 || 0;
      _this.pageScroll(anchorPosition, headerHeight);
    }
  },

  TweenMax: function () {
    let magnets = document.querySelectorAll(".TweenMax-item");
    let strength = 50;

    magnets.forEach((magnet) => {
      magnet.addEventListener("mousemove", moveMagnet);
      magnet.addEventListener("mouseout", function (event) {
        TweenMax.to(event.currentTarget, 1, {
          x: 0,
          y: 0,
          ease: Power4.easeOut,
        });
      });
    });

    function moveMagnet(event) {
      let magnetButton = event.currentTarget;
      let bounding = magnetButton.getBoundingClientRect();
      TweenMax.to(magnetButton, 1, {
        x:
          ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) *
          strength,
        y:
          ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) *
          strength,
        ease: Power4.easeOut,
      });
    }
  },

  customScrollBar: function () {
    if ($("#bss-map-search-box").length > 0) {
      const scrollbarHtml = $(`
          <div class="inner-scrollbar">
            <div class="scroll-thumb" id="thumb"></div>  
          </div>
      `);
      $("#bss-map-search-box").append(scrollbarHtml);



      const content = $('#bss-map-search-box .custom-scrollbar');
      const scrollbar = $('#bss-map-search-box .inner-scrollbar');
      const thumb = $('#thumb');

      function updateScrollbar() {
        const containerHeight = $('#bss-map-search-box').height();
        const contentHeight = content.prop('scrollHeight');
        const maxScrollTop = contentHeight - Math.ceil(containerHeight);


        if (maxScrollTop <= 0) {
          scrollbar.hide();
          return;
        }
        scrollbar.show();

        const thumbHeight = Math.min(
          containerHeight,
          Math.max(30, (containerHeight / contentHeight) * containerHeight)
        );
        thumb.height(thumbHeight);

        const scrollRatio = (containerHeight - thumbHeight) / maxScrollTop;
        const thumbTop = content.scrollTop() * scrollRatio;
        thumb.css('top', `${thumbTop}px`);
      }

      updateScrollbar();

      $(window).on('resize', () => {
        updateScrollbar();
      })

      const observer = new MutationObserver((mutations) => {
        updateScrollbar();
      });

      observer.observe($(".custom-scrollbar #bss-search-result")[0], {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
      });

      content.on('scroll', () => {
        const containerHeight = $('#bss-map-search-box').height();
        const contentHeight = content.prop('scrollHeight');
        const maxScrollTop = contentHeight - containerHeight;
        const thumbHeight = thumb.height();

        if (maxScrollTop <= 0) return;

        const scrollRatio = (containerHeight - thumbHeight) / maxScrollTop;
        const thumbTop = content.scrollTop() * scrollRatio;
        thumb.css('top', `${thumbTop}px`);
      });

      let isDragging = false;
      let startY;
      let startScrollTop;

      thumb.on('mousedown', (e) => {
        startDrag(e.clientY);
        e.preventDefault();
      });

      $(document).on('mousemove', (e) => {
        if (isDragging) {
          handleDrag(e.clientY);
        }
      });

      $(document).on('mouseup', endDrag);



      thumb[0].addEventListener('touchstart', function (e) {
        e.preventDefault();
        const touchY = e.touches[0].clientY;
        startDrag(touchY);
      }, { passive: false });

      document.addEventListener('touchmove', function (e) {
        if (isDragging) {
          e.preventDefault();
          const touchY = e.touches[0].clientY;
          handleDrag(touchY);
        }
      }, { passive: false });

      $(document).on('touchend', function (e) {
        endDrag();
      });

      function startDrag(clientY) {
        isDragging = true;
        startY = clientY;
        startScrollTop = content.scrollTop();
        thumb.css('left', '0');
      }

      function handleDrag(clientY) {
        const containerHeight = $('#bss-map-search-box').height();
        const contentHeight = content.prop('scrollHeight');
        const maxScrollTop = contentHeight - containerHeight;
        const thumbHeight = thumb.height();

        const deltaY = clientY - startY;
        const scrollRatio = maxScrollTop / (containerHeight - thumbHeight || 1);
        let newScrollTop = startScrollTop + deltaY * scrollRatio;

        newScrollTop = Math.max(0, Math.min(newScrollTop, maxScrollTop));
        content.scrollTop(newScrollTop);
      }

      function endDrag() {
        isDragging = false;
        thumb.css('left', '-1px');
      }

      scrollbar.on('click', function (e) {
        if ($(e.target).is(thumb)) return;

        if (isDragging) return;

        const container = $('#bss-map-search-box');
        const containerHeight = container.height();
        const contentHeight = content.prop('scrollHeight');
        const maxScrollTop = contentHeight - containerHeight;
        const thumbHeight = thumb.height();

        if (maxScrollTop <= 0) return;

        const clickPos = e.clientY - container[0].getBoundingClientRect().top;

        const scrollRatio = maxScrollTop / (containerHeight - thumbHeight || 1);
        let newScrollTop = (clickPos - thumbHeight / 2) * scrollRatio;

        newScrollTop = Math.max(0, Math.min(newScrollTop, maxScrollTop));

        // content.scrollTop(newScrollTop);
        content.animate({ scrollTop: newScrollTop }, 300);
      });


    }
  },
};

let $ = jQuery.noConflict();
$(document).ready(function () {
  morph.init();

  $(".copy-link-btn").click(function () {
    const currentUrl = window.location.href;

    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        return;
      })
      .catch((err) => {
        return;
      });
  });


  const targetElement = document.querySelector('.cart-drawer__summary .cart__summary-totals');

  if (targetElement) {

    const observer = new MutationObserver((mutations) => {
      let hasSignificantChange = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          hasSignificantChange = true;
        } else if (mutation.type === 'characterData') {
          hasSignificantChange = true;
        } else if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'open' && mutation.target.matches('details.discount-details')) {
            hasSignificantChange = true;
          }
        }
      });

      if (hasSignificantChange) {
        setTimeout(() => {
          if ($("header").length > 0) {
            const stickyCartDom = $(".cart-drawer__content .cart-drawer__summary ");
            const height = stickyCartDom.outerHeight();

            $("body").css({
              "--sticky-cart-height": height + "px",
            })
          }
        }, 300);
      }
    });

    const config = {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    };

    observer.observe(targetElement, config);
  } else {
    return;
  }

});

$(window).on("scroll", function () {
  morph.wowo();
  morph.nav();
});

$(window).on("resize", function () {
  morph.appHeight();
});
